import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpApiService} from './http-api.service';
import {Circulation} from "../../models/circulations.model";

@Injectable({
  providedIn: 'root'
})
export class CirculationApiService {
  private readonly allCinemaEndpoint = 'circulation/all_cinema';
  private readonly getCirculationsEndpoint = 'circulation/get_circulations';
  private readonly removeCirculationEndpoint = 'circulation/delete_circul';
  private readonly addCirculationEndpoint = 'circulation/add_new_circul';
  private readonly setCirculationEndpoint = 'circulation/modif_circul';


  constructor(private httpApiService: HttpApiService) {
  }

  public getCinemas(cookies: string, params: any): Observable<any> {
    return this.httpApiService.get<any>(this.allCinemaEndpoint, params, cookies);
  }

  public getCirculations(cookies: string, id_film: number): Observable<any> {
    const params = {
      id_film: id_film,
    };
    return this.httpApiService.get<any>(this.getCirculationsEndpoint, params, cookies);
  }

  removeCirculation(cookies: string, idCirculation: number): Observable<any> {
    return this.httpApiService.delete<any>(this.removeCirculationEndpoint, {'id_circul': idCirculation}, cookies);
  }

  public addCirculation(cookies: string, params: any | null): Observable<any> {
    return this.httpApiService.post<any>(this.addCirculationEndpoint, params, cookies);
  }

  public setCirculation(cookies: string, params: any | null): Observable<any> {
    return this.httpApiService.post<any>(this.setCirculationEndpoint, params, cookies);
  }

}
